// angular import
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// project import
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GuestComponent } from './theme/layout/guest/guest.component';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { ConfigurationComponent } from './theme/layout/admin/configuration/configuration.component';
import { NavBarComponent } from './theme/layout/admin/nav-bar/nav-bar.component';
import { NavigationComponent } from './theme/layout/admin/navigation/navigation.component';
import { NavLeftComponent } from './theme/layout/admin/nav-bar/nav-left/nav-left.component';
import { NavRightComponent } from './theme/layout/admin/nav-bar/nav-right/nav-right.component';
import { NavContentComponent } from './theme/layout/admin/navigation/nav-content/nav-content.component';
import { NavLogoComponent } from './theme/layout/admin/navigation/nav-logo/nav-logo.component';
import { NavCollapseComponent } from './theme/layout/admin/navigation/nav-content/nav-collapse/nav-collapse.component';
import { NavGroupComponent } from './theme/layout/admin/navigation/nav-content/nav-group/nav-group.component';
import { NavItemComponent } from './theme/layout/admin/navigation/nav-content/nav-item/nav-item.component';
import { NavSearchComponent } from './theme/layout/admin/nav-bar/nav-left/nav-search/nav-search.component';
import { NavigationItem } from './theme/layout/admin/navigation/navigation';
import { ChatMsgComponent } from './theme/layout/admin/nav-bar/nav-right/chat-msg/chat-msg.component';
import { ChatUserListComponent } from './theme/layout/admin/nav-bar/nav-right/chat-user-list/chat-user-list.component';
import { FriendComponent } from './theme/layout/admin/nav-bar/nav-right/chat-user-list/friend/friend.component';
import { ToggleFullScreenDirective } from './theme/shared/full-screen/toggle-full-screen';
import { ToastrModule } from 'ngx-toastr';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { BasicAuthInterceptor } from 'src/app/theme/shared/_helpers/basic-auth.interceptor';
import { NgbDateAdapter, NgbDateNativeAdapter, NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { CustomDateParserFormatter } from './shared/DateFormat/DateParseformat';
import { ThirdpartyagentsComponent } from './modules/accounts/thirdpartyagents/thirdpartyagents.component';
import { NotesModule } from './modules/accounts/notes/notes.module';
import { ApprovalstatusComponent } from './modules/accounts/approvalstatus/approvalstatus.component';
import { TaxadviserdetailsComponent } from './modules/accounts/taxadviserdetails/taxadviserdetails.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { AceEditorModule } from 'ng12-ace-editor';
import { NgJsonEditorModule } from 'ang-jsoneditor';
import { MaterialModule } from './shared/material/material.module';
import { OAuthModule, OAuthService, OAuthStorage } from 'angular-oauth2-oidc';
import { ConfigurationService } from './Configuration/configuration.service';
import { AuthConfigService } from './Configuration/auth-config.service';
import { AuthGuard } from './core/guards/auth.guard';
import { TokenInterceptorService } from './core/interceptors/token-interceptor.service';
import { ErrorInterceptor } from './core/helpers/error.interceptor';
import { SharedModule } from './theme/shared/shared.module';
import { CreateRequestGuardService } from './shared/create-requestguard.service';
import { FooterComponent } from './theme/layout/admin/nav-bar/footer/footer.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
const configurationFactory = (configurationService: ConfigurationService) => {
  return () => configurationService.loadConfiguration();
};
export function storageFactory(): OAuthStorage {
  return sessionStorage
}

@NgModule({
  declarations: [
    AppComponent,
    GuestComponent,
    AdminComponent,
    ConfigurationComponent,
    NavBarComponent,
    NavigationComponent,
    NavLeftComponent,
    NavRightComponent,
    NavContentComponent,
    NavLogoComponent,
    NavCollapseComponent,
    NavGroupComponent,
    NavItemComponent,
    NavSearchComponent,
    ChatMsgComponent,
    ChatUserListComponent,
    FriendComponent,
    ToggleFullScreenDirective,
    FooterComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule, NgSelectModule, NotesModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    HttpClientModule, AceEditorModule,
    NgbModule, NgSelectModule, NgJsonEditorModule, OAuthModule.forRoot(), PdfViewerModule, PdfJsViewerModule
  ],
  providers: [
    NavigationItem, DatePipe,
    //{ provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true },
    //{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    CreateRequestGuardService, AuthGuard, AuthConfigService, ConfigurationService,
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    { provide: NgbDateParserFormatter, useClass: NgbDateNativeAdapter },
    { provide: OAuthStorage, useFactory: storageFactory },
    {
      provide: APP_INITIALIZER,
      useFactory: configurationFactory,
      deps: [ConfigurationService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
